import I18n from 'I18n';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { asHubHttpApolloError } from 'messaging-management-lib/errors/utils';
import Raven from 'raven-js';
export function handleCloneError(error, payload) {
  var _retypedError$network, _retypedError$network2;
  const retypedError = asHubHttpApolloError(error);
  if ((_retypedError$network = retypedError.networkError) !== null && _retypedError$network !== void 0 && _retypedError$network.responseJSON && 'errorType' in retypedError.networkError.responseJSON && retypedError.networkError.responseJSON.errorType === 'OBJECT_LIMIT_REACHED_FOR_PORTAL') {
    FloatingAlertStore.addAlert({
      type: 'danger',
      message: I18n.text('email-management.errors.email.clone2.limitReached')
    });
  } else {
    FloatingAlertStore.addAlert({
      type: 'danger',
      message: I18n.text('email-management.errors.email.clone2.default')
    });
  }
  if (((_retypedError$network2 = retypedError.networkError) === null || _retypedError$network2 === void 0 ? void 0 : _retypedError$network2.status) !== 0) {
    var _retypedError$network3, _retypedError$network4;
    Raven.captureException(new Error('Error when cloning email'), {
      extra: {
        message: (_retypedError$network3 = (_retypedError$network4 = retypedError.networkError) === null || _retypedError$network4 === void 0 || (_retypedError$network4 = _retypedError$network4.responseJSON) === null || _retypedError$network4 === void 0 ? void 0 : _retypedError$network4.message) !== null && _retypedError$network3 !== void 0 ? _retypedError$network3 : retypedError.message,
        payload
      }
    });
  }
}